import React, { FC } from 'react';
import { useUpdateApprovalPostStatus } from 'app/modules/posts/modules/detail/hooks/useUpdateApprovalPostStatus';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'utils/hooks/useEffectOnce';
import { CommentConvertor } from 'app/modules/comments/utils/commentConvertor';
import { ActivityIndicator } from '@kontentino/ui';

type Props = {
  postId: number;
  status: number;
  onSettled: () => void;
};
export const RespondToApprovalRequest: FC<Props> = ({
  postId,
  status,
  onSettled,
}) => {
  const { updateThroughComment } = useUpdateApprovalPostStatus({ postId });
  const { t } = useTranslation();

  useEffectOnce(() => {
    const respondToApproval = async () => {
      const commentType = CommentConvertor.statusToCommentType(status);

      try {
        await updateThroughComment.mutateAsync({
          thread: commentType?.includes('client') ? 'client' : 'internal',
          text: t(
            commentType.includes('approve')
              ? 'commentsWorkflowMessages.approve'
              : 'commentsWorkflowMessages.rework',
          ),
          action: CommentConvertor.statusToCommentAction(status),
        });
      } finally {
        onSettled();
      }
    };

    respondToApproval();
  });

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-p-4 tw-pb-8">
      {updateThroughComment.isLoading && (
        <ActivityIndicator className="tw-h-8 tw-w-8 tw-shrink-0" />
      )}
    </div>
  );
};
